import { SyntheticEvent } from 'react'

const defaultUrl = 'galaxy/images/product-list/default.png';
const setDefaultImageUrl = (event: SyntheticEvent<HTMLImageElement>, imageServerUrl?: string|undefined) => {
	event.currentTarget.src = imageServerUrl + defaultUrl; // 放入預設image url
}

const validateImageUrl = async (url: string, imageServerUrl?: string|undefined): Promise<string> => {
	return new Promise((resolve) => {
		const img = new Image();
		img.onload = () => resolve(`${imageServerUrl}${url}`);
		img.onerror = () => resolve(`${imageServerUrl}${defaultUrl}`);
		img.src = `${imageServerUrl}${url}`;
	})
};

export const defaultImageService = {
	setDefaultImageUrl: setDefaultImageUrl,
	validateImageUrl: validateImageUrl
}